import { Col, DatePicker, Modal, Row, TimePicker } from 'antd';
import { Input } from 'components/customInputs';
import { Heading } from 'components/Typography';
import React, { useEffect, useState } from 'react';
import {Button} from 'components/Button';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment/moment';
import { editRequest, requestLeaveOrAttendance, getAttendanceRequests } from 'actions/profileNew';
import { connect } from 'react-redux';
import { attendanceRequirementDetail } from 'actions/attendanceNew';
import { Notification } from 'services';


const MarkAttendanceModal = ({
    visible, onClose, attendanceFormDetails, setAttendanceFormDetails, requestLeaveOrAttendance, 
    setPageLoader, filter, setFilter, user, fromWhere, userRowDetails, isEdit,
    getattendanceRequirement, attendanceRequests, getAttendanceSetting, getAttendanceRequests
}) => {

    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        if (attendanceFormDetails.clockIn && attendanceFormDetails.clockOut && moment(attendanceFormDetails.clockOut).isAfter(moment(attendanceFormDetails.clockIn))) {
            var dif = moment.duration(attendanceFormDetails.clockOut.diff(attendanceFormDetails.clockIn));
            attendanceFormDetails.totalHours = ("0" + dif.hours()).slice(-2) + ":" + ("0" + dif.minutes()).slice(-2);
        } else {
            attendanceFormDetails.totalHours = "00:00";
        }
        setAttendanceFormDetails({...attendanceFormDetails})
    }, [attendanceFormDetails.clockIn, attendanceFormDetails.clockOut]);

    useEffect(() => {
        if (visible && getAttendanceSetting) {
            getAttendanceSetting();
            const targetUserId = fromWhere == 'userManagementProfile' ? userRowDetails?.id : user?.id;
            if (targetUserId && getAttendanceRequests) {
                getAttendanceRequests({ userId: targetUserId, page: 1, limit: 100 }, () => {});
            }
        }
    }, [visible]);

    // const disabledDate = (current) => {
    //     // Can not select days before today and today
    //     return current && current >= moment();
    //   };

    const handleSaveClick = () => {
        // Enforce limit check for regular users (not SuperAdmin) when not editing
        if (!user?.privilage?.includes('SuperAdmin') && isEdit !== 'edit') {
            const role = fromWhere === 'userManagementProfile' ? userRowDetails?.role : user?.role;
            const roleStr = Array.isArray(role) ? role[0] : role;
            
            let limit = null;
            if (getattendanceRequirement) {
                if (roleStr === 'Teacher') {
                    limit = getattendanceRequirement.requestCountTeacher;
                } else if (roleStr === 'Data Operator') {
                    limit = getattendanceRequirement.requestCountDO;
                } else if (roleStr === 'Operation') {
                    limit = getattendanceRequirement.requestCountOperation;
                } else if (roleStr === 'Student') {
                    limit = getattendanceRequirement.requestCountStudent;
                }
            }

            if (limit !== null && limit !== undefined && !isNaN(parseInt(limit, 10))) {
                const parsedLimit = parseInt(limit, 10);
                const selectedMonthStr = moment(attendanceFormDetails.date).format("YYYY-MM");
                const manualPunchesThisMonth = (attendanceRequests?.items || []).filter(item => {
                    const isAttendance = item.requestType?.toUpperCase() === "ATTENDANCE";
                    const isApprovedOrPending = item.status?.toUpperCase() === "APPROVED" || item.status?.toUpperCase() === "PENDING";
                    const matchesMonth = item.startDate && moment(item.startDate).format("YYYY-MM") === selectedMonthStr;
                    return isAttendance && isApprovedOrPending && matchesMonth;
                });
                const currentCount = manualPunchesThisMonth.length;
                if (currentCount >= parsedLimit) {
                    Notification.error("Error", "Manual punch limit for this month has been exceeded");
                    return;
                }
            }
        }

        const params = {
            userId: fromWhere == 'userManagementProfile' ? userRowDetails?.id : user?.id, 
            commonId: attendanceFormDetails.commonId || attendanceFormDetails.id,
            requestType: "Attendance",
            startDate: moment(attendanceFormDetails.date).format("YYYY-MM-DD"),
            clockIn: moment(attendanceFormDetails.clockIn).format("HH:mm:ss"),
            clockOut: moment(attendanceFormDetails.clockOut).format("HH:mm:ss"),
            reason: attendanceFormDetails.reason,
            totalhours: attendanceFormDetails.totalHours,
            page: 1,
            limit: filter.limit
        }
        console.log({params});
        setButtonLoader(true)
        requestLeaveOrAttendance(params,() => setButtonLoader(false), onClose, pagecallback)
    }

    const pagecallback = (state) => {
        setPageLoader(state);
        setFilter({...filter, page:1})
    }

    function onKeyDown(event) {
        event.preventDefault();
    };

    function disabledDate(current) {
        return current && (current < moment().add(-4, "days") || current > moment().add(-1, "days"))
    }

    const disabledClockOutHours = () => {
        if (!attendanceFormDetails.clockIn) return [];
        const clockInHour = attendanceFormDetails.clockIn.hour();
        const hours = [];
        for (let i = 0; i < clockInHour; i++) {
            hours.push(i);
        }
        return hours;
    };

    const disabledClockOutMinutes = (selectedHour) => {
        if (!attendanceFormDetails.clockIn) return [];
        const clockInHour = attendanceFormDetails.clockIn.hour();
        const clockInMinute = attendanceFormDetails.clockIn.minute();
        const minutes = [];
        if (selectedHour === clockInHour) {
            for (let i = 0; i <= clockInMinute; i++) {
                minutes.push(i);
            }
        }
        return minutes;
    };

    return (
        <Modal
            open={visible}
            footer={false}
            className="modal-round-corner"
            onCancel={onClose}
        >
            <div className='r-c-c m-t-20'>
                <Heading>{user?.privilage?.includes('SuperAdmin')  ? isEdit == 'edit'? "EDIT ATTENDANCE" :"MARK ATTENDANCE" : isEdit == 'edit'? "EDIT ATTENDANCE" :"REQUEST ATTENDANCE"}</Heading>
            </div>
            <div className='p-20'>
                <div>Date <span style={{ color: "red" }}>*</span></div>
                <DatePicker  
                disabled  = {isEdit == 'edit' ? true : false}
                format='DD-MM-YYYY'
                    style={{width: "100%"}} 
                    value={attendanceFormDetails.date} 
                    // value={moment(attendanceFormDetails.date, 'YYYY-MM-DD').format('DD-MM-YYYY')} 
                    onChange={(value) => setAttendanceFormDetails({...attendanceFormDetails, date: value})}
                    disabledDate={disabledDate}
                    onKeyDown={onKeyDown}
                />
            </div>
            <Row className='p-20' style={{paddingTop: 0}}>
                <Col span={12}>
                    <div>Clock in <span style={{ color: "red" }}>*</span></div>
                    <TimePicker 
                        key={attendanceFormDetails.clockIn ? attendanceFormDetails.clockIn.toString() : 'empty'}
                        style={{width: "100%"}}  
                        format="HH:mm" 
                        value={attendanceFormDetails.clockIn} 
                        onChange={(value) => {
                            if (!value) {
                                setAttendanceFormDetails({...attendanceFormDetails, clockIn: null, clockOut: null});
                            } else {
                                setAttendanceFormDetails({...attendanceFormDetails, clockIn: value});
                            }
                        }}
                        onKeyDown={onKeyDown}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                    />
                </Col>
                <Col span={11} offset={1}>
                    <div>Clock out <span style={{ color: "red" }}>*</span></div>
                    <TimePicker 
                        key={attendanceFormDetails.clockOut ? attendanceFormDetails.clockOut.toString() : 'empty'}
                        style={{width: "100%"}}  
                        format="HH:mm" 
                        value={attendanceFormDetails.clockOut}
                        onChange={(value) => setAttendanceFormDetails({...attendanceFormDetails, clockOut: value})}
                        disabled={!attendanceFormDetails.clockIn}
                        onKeyDown={onKeyDown}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        disabledHours={disabledClockOutHours}
                        disabledMinutes={disabledClockOutMinutes}
                    />
                </Col>
            </Row>
            <div className='p-20' style={{paddingTop: 0}}>
                <div>Total hours <span style={{ color: "red" }}>*</span></div>
                
                <Input 
                    disabled 
                    style={{
                        width: "100%", 
                        backgroundColor: "#FAFAFA", 
                        color: "#AEAEAE", 
                        cursor: "not-allowed"
                    }} 
                    placeholder="Total Hours" 
                    value={attendanceFormDetails.clockIn > attendanceFormDetails.clockOut || attendanceFormDetails.totalHours ==  'aN:aN' ? "00:00" : attendanceFormDetails.totalHours} 
                />
            </div>
            <div className='p-20' style={{paddingTop: 0}}>
                <div>Reason <span style={{ color: "red" }}>*</span></div>
                <TextArea 
                    placeholder='Enter reason'
                    style={{resize: "none", height: 100}}
                    value={attendanceFormDetails.reason}
                    onChange={(e) => setAttendanceFormDetails({...attendanceFormDetails, reason: e.target.value})}
                />
            </div>

            <div className='r-c-c m-t-40'>
                <Button type="primary"
                    onClick={handleSaveClick}
                    loading={buttonLoader}
                    disabled={
                        !attendanceFormDetails.date || !attendanceFormDetails.clockIn || 
                        !attendanceFormDetails.clockOut || 
                        moment(attendanceFormDetails.clockOut).isSameOrBefore(moment(attendanceFormDetails.clockIn)) ||
                        !attendanceFormDetails.reason || attendanceFormDetails.reason?.trim() === ""
                    }
                >{(user?.privilage?.includes('SuperAdmin')) ? isEdit == 'edit' ? "UPDATE":"MARK" : isEdit == 'edit' ? "UPDATE":"REQUEST"}</Button>
            </div>

        </Modal>
    );
}


const mapStateToProps = (state) => { 
    const {user} = state.session;
    const { leaveDetails, attendanceRequests } = state.profileNew;
    const {userRowDetails} = state.userManagementV2;
    const { getattendanceRequirement } = state.attendanceNew;
    return {
        leaveDetails, user, userRowDetails, getattendanceRequirement, attendanceRequests
    }
}

const mapDispatchToProps = (dispatch) => ({
    requestLeaveOrAttendance: (params, callback, successCallback, pagecallback) => dispatch(requestLeaveOrAttendance(params, callback, successCallback, pagecallback)),
    getAttendanceSetting: () => dispatch(attendanceRequirementDetail()),
    getAttendanceRequests: (params, callback) => dispatch(getAttendanceRequests(params, callback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MarkAttendanceModal);

